import NotificationPopover from '@koob/notifications/src/components/NotificationPopover';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from 'hooks';

export default function NotificationDropdown() {
  const navigate = useNavigate();
  const {
    notifications,
    loading,
    markAsRead,
    markAllAsRead,
    reloadNotifications,
  } = useNotifications();

  return (
    <NotificationPopover
      notifications={notifications}
      loading={loading}
      markAsRead={markAsRead}
      markAllAsRead={markAllAsRead}
      navigate={navigate}
      reload={reloadNotifications}
      scope="dmc"
    />
  );
}
